<template>
  <div class="user_container">
    <div class="goback">
      <div>
        <span>公益提报审批列表</span>
      </div>
    </div>
    <div class="detail_title_info">
      <van-tabs v-model="active" @change="tabChange">
        <van-tab title="待审批">
          <list ref="list" :type="type"></list>
        </van-tab>
        <van-tab title="已审批">
          <list
            ref="list2"
            :type="type"
          ></list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import list from "./personalRecordList";
// import api from "@/apis/medal";
export default {
  name: "detail",
  props: {},
  components: {
    list,
  },
  data() {
    return {
      active: 0,
      type: "1",
    };
  },
  created() {},
  mounted() {
  },
  methods: {
    //切换tab
    tabChange(index) {
      if (index == 0) {
        this.type = "1";
      } else {
        this.type = "4";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px 30px 0;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    // height: 100%;
    position: relative;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
::v-deep {
  .van-tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .van-tabs__wrap {
    margin-bottom: 30px;
    height: 80px;
  }
  .van-tabs__content {
    flex: 1;
    overflow: auto;
  }
  .van-tab__pane {
    height: 100%;
  }
}
::v-deep .van-tabs__nav {
  background: transparent;
  display: block;
  .van-tab {
    float: left;
    width: 200px;
    height: 100%;
    font-size: 32px;
    line-height: 66px;
    color: #969b9e;
  }
  .van-tab--active {
    color: #1fbe8a;
    background: #fff;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
    border-radius: 16px;
  }
  .van-tabs__line {
    width: 0;
    height: 0;
    // background: #4ea27c;
  }
}
.pick {
  position: absolute;
  top: 0;
  right: 0;
  width: 34%;
  height: 80px;
  border-radius: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-bottom: 15px;
  .newDate {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
  }
  div {
    color: #969b9e;
    font-size: 30px;
  }
  i {
    color: #969b9e;
  }
}
</style>
